module.exports = __webpack_public_path__ + "media/assets/9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/9.svg
// module id = 21
// module chunks = 0